import type { Role } from '@pl/domain';

export const homeFor = (role: Role): '/office' | '/scan' => (role === 'worker' || role === 'lead' ? '/scan' : '/office');
export const canUse = (role: Role, surface: 'office' | 'scan') => (surface === 'scan' ? role !== 'office' : role !== 'worker');
